import { Platform } from '@angular/cdk/platform';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Planning } from '../../../classes/planning.class';

@Component({
    selector: 'app-planning-detail-container',
    templateUrl: './planning-detail-container.component.html',
    styleUrls: ['./planning-detail-container.component.scss'],
    standalone: false,
})
export class PlanningDetailContainerComponent implements AfterViewInit {
    loadChild = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public planning: Planning,
        public platform: Platform,
        public dialogRef: MatDialogRef<PlanningDetailContainerComponent>
    ) {}

    ngAfterViewInit() {
        let timeOut = null;
        if (this.platform.IOS || this.platform.SAFARI) {
            timeOut = 200;
        }
        setTimeout(() => {
            this.loadChild = true;
        }, timeOut);
    }
}
